import { DateTime } from 'luxon';

// transforma una cantidad de dinero a una cadena con el formato de moneda
export const formatMoney = (amount, decimalCount = 2, decimal = ".", thousands = ",") => {
    try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;
        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        alert('Los precios deben contener solo valores numéricos, sin letras ni símbolos');
        console.log(e)
    }
}

// transforma una cantidad de dinero a una cadena con el formato de moneda
export const formatMoneyDecimal = (amount, decimalCount , decimal = ".", thousands = ",") => {
    try {
        // decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
        decimalCount = decimalCount > 6 ? 6 : decimalCount;
        decimalCount = decimalCount < 2 ? 2 : decimalCount;
        const negativeSign = amount < 0 ? "-" : "";
        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;
        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
        alert('Los precios deben contener solo valores numéricos, sin letras ni símbolos');
        console.log(e)
    }
}

// obtiene la fecha en el formato deseado
export const getDate = (date, format) => {
    const dateD = DateTime.fromISO(date);
    return dateD.isValid ? dateD.setLocale('es').toFormat(format ? format : 'dd/MM/yyyy') : '';
  }

  export const usuarios = ['Abdias Lopez', 'Jorge Benítez', 'Daniel Cruz', 'Eduardo Alanis']

 export const terminosCondiciones = [
    {
        uuid: 'e881b63c-e563-44c2-b2e8-a120fbc579c6',
        key: 'Condiciones de pago: ',
        value: '100% pago por anticipado.',
    },
    {
        uuid: 'bdd98880-5c1e-4e52-8c43-fc792cd857c3',
        key: 'Tiempo de entrega: ',
        value: '8 días hábiles.',
    },
    {
        uuid: '08f3c0e8-cb34-4c6a-a1f5-1fdbce6ab8a1',
        key: 'Vigencia: ',
        value: '15 días.',
    },
    {
        uuid: 'fc11f7fd-ded7-4fc7-a9bd-63f25a575acf',
        key: 'Garantía: ',
        value: '30 días hábiles por defecto de fabricación.',
    },
    {
        uuid: '029bb377-7252-4a7c-82c1-b51608ae0809',
        key: 'Forma de pago: ',
        value: 'Transferencia Electrónica o Depósito Bancario',
    },
    {
        uuid: '6202a71d-5871-4310-826c-3ecf9b70fa8d',
        key: 'Precios sujetos a cambio sin previo aviso.',
    },
]